// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxCircleFilledSvg from "@fishx/icons-svg/es/asn/DropboxCircleFilled";
import FishxIcon from '../components/FishxIcon';

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxCircleFilledSvg
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
export default React.forwardRef(DropboxCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DropboxCircleFilled.js
// module id = 2484
// module chunks = 0